import * as settings from "../../constants/settings";

/**
 * @class FileTransferTask
 */
export default class FileTransferTask {
    /**
     * @param {String}          name
     * @param {String}          format
     * @param {Object}          formatOptions
     * @param {String}          protocol
     * @param {Object}          protocolOptions
     */
    constructor(name, format, formatOptions, protocol, protocolOptions) {
        this._key = this.calculateKey(
            format,
            protocol,
            protocolOptions.folder_path === undefined ? null : protocolOptions.folder_path,
            protocolOptions.host === undefined ? null : protocolOptions.host,
            protocolOptions.port === undefined ? null : protocolOptions.port,
            protocolOptions.folder === undefined ? null : protocolOptions.folder
        );
        this._name = name;
        this._format = format;
        this._formatOptions = formatOptions;
        this._protocol = protocol;
        this._protocolOptions = protocolOptions;
    }

    /**
     * @return {String | null}
     */
    get name() {
        return this._name;
    }

    /**
     * @return {String}
     */
    get format() {
        return this._format;
    }

    /**
     * @return {Object}
     */
    get formatOptions() {
        return this._formatOptions;
    }

    /**
     * @return {String}
     */
    get protocol() {
        return this._protocol;
    }

    /**
     * @return {Object}
     */
    get protocolOptions() {
        return this._protocolOptions;
    }

    /**
     * Creates hash to compare file transfer task objects.
     *
     * @param   {String}        format
     * @param   {String}        protocol
     * @param   {String | null} folderPath
     * @param   {String | null} host
     * @param   {Number | null} port
     * @param   {String | null} remoteFolder
     * @return  {String}
     */
    calculateKey = (format, protocol, folderPath = null, host = null, port = null, remoteFolder = null) => {
        let key = null;

        switch (format) {
            case settings.DESO_CUSTOM_FORMULA_XML:
                key = "01-";
                break;
            case settings.DESO_CUSTOMER_XML:
                key = "02-";
                break;
            case settings.DESO_HISTORY_XML:
                key = "03-";
                break;
            case settings.DESO_ORDER_XML:
                key = "04-";
                break;
            default:
                key = "00-";
                break;
        }

        switch (protocol) {
            case settings.PROTOCOL_FOLDER:
                key += "01";

                if (folderPath !== null) {
                    key += "-" + folderPath;
                }

                break;
            case settings.PROTOCOL_FTP:
                key += "02";
                break;
            case settings.PROTOCOL_FTPS:
                key += "03";
                break;
            case settings.PROTOCOL_REDLIKE_STORAGE:
                key += "04";
                break;
            case settings.PROTOCOL_SFTP:
                key += "05";
                break;
            default:
                key += "00";
                break;
        }

        if (
            protocol === settings.PROTOCOL_FTP ||
            protocol === settings.PROTOCOL_FTPS ||
            protocol === settings.PROTOCOL_SFTP
        ) {
            let sha256 = require("sha256");

            if (host !== null) {
                key += "-" + host;
            }

            if (port !== null) {
                key += "-" + port;
            }

            if (remoteFolder !== null) {
                key += "-" + remoteFolder;
            }

            return sha256(key);
        }

        return key;
    };

    /**
     * @return  {String}
     */
    getKey = () => {
        return this._key;
    };

    /**
     * @param   {String}        format
     * @param   {String}        protocol
     * @param   {String | null} folderPath
     * @param   {String | null} host
     * @param   {Number | null} port
     * @param   {String | null} remoteFolder
     * @return  {Boolean}
     */
    compareTo = (format, protocol, folderPath = null, host = null, port = null, remoteFolder = null) => {
        return this.calculateKey(format, protocol, folderPath, host, port, remoteFolder) === this._key;
    };
}
